__turbopack_context__.v({
  "quoteBarContainer": "QuoteBar-module-scss-module__M5uW4a__quoteBarContainer",
  "quoteListFaded": "QuoteBar-module-scss-module__M5uW4a__quoteListFaded",
  "quoteListReady": "QuoteBar-module-scss-module__M5uW4a__quoteListReady",
});
